import * as React from 'react';
import { Box, Text } from "../..";
import { _getInputLabelStyles } from "./InputLabel.styles";

var InputLabel = function InputLabel(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      isInputFilled = _ref.isInputFilled,
      isInputFocused = _ref.isInputFocused,
      disabled = _ref.disabled,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required;
  return /*#__PURE__*/React.createElement(Box, {
    as: "label",
    sx: _getInputLabelStyles({
      size: size,
      isInputFilled: isInputFilled,
      isInputFocused: isInputFocused,
      disabled: disabled
    })
  }, label, required && /*#__PURE__*/React.createElement(Text, {
    as: "span",
    color: "red.500",
    pl: 1
  }, "*"));
};

export { InputLabel };
export default InputLabel;